module.exports = __webpack_public_path__ + "static/car-5933783f81ba39c38c71bf2955bb5baf.png";